import type { CookieStyles } from "@/types/cookie-banner/styles";

export function createCookieStyles(styles: CookieStyles) {
  return styles;
}
